import script from "./credit.vue?vue&type=script&setup=true&lang=js"
export * from "./credit.vue?vue&type=script&setup=true&lang=js"

import "./credit.vue?vue&type=style&index=0&id=460ec322&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460ec322"]])

export default __exports__